import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { mapMetaData } from '../helpers/seoHelpers';

export const MetaData = (props) => {
  const {
    nonce,
    page: { meta, structuredDataSeo, title },
  } = props;

  return (
    <Helmet>
      <title>{meta?.title || title}</title>
      {meta && mapMetaData(meta, title)}

      {/* Output JSON-LD structured data */}
      {structuredDataSeo && (
        <script type="application/ld+json" nonce={nonce}>
          {JSON.stringify(structuredDataSeo)}
        </script>
      )}
    </Helmet>
  );
};

MetaData.propTypes = {
  nonce: PropTypes.string,
  page: PropTypes.shape({
    meta: PropTypes.object,
    structuredDataSeo: PropTypes.object,
    title: PropTypes.string,
  }),
};
